import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchInputComponent } from '../search-input/search-input.component';

@Component({
  selector: 'app-otp-input',
  imports: [TranslateModule, SearchInputComponent],
  templateUrl: './otp-input.component.html',
  styleUrl: './otp-input.component.scss',
})
export class OtpInputComponent implements OnDestroy {
  @Output() otpSend = new EventEmitter();
  isButtonClicked = false;

  @Input({ required: true })
  textControl!: FormControl<string>;

  @Input({ required: true })
  identifier!: string;

  timeLeft = 30;
  interval: NodeJS.Timeout | null = null;
  retryAttempts = 1;

  startTimer() {
    this.timeLeft = 30;
    this.isButtonClicked = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.isButtonClicked = false;
        clearInterval(this.interval!);
      }
    }, 1000);
  }

  emitOtpSend() {
    this.isButtonClicked = true;

    this.startTimer();
    this.otpSend.emit();
  }

  ngOnDestroy(): void {
    clearInterval(this.interval!);
  }
}
